import React from 'react'
import { trackButtonClicked, TrackedButtonNames } from '@utils/analytics'
import { ArtistEditorialPageDetailsFragment } from '@/gql/generated/graphql'
import { InstagramLogoIcon, XLogoIcon } from 'design-configuration/components'
import { GlobeIcon } from 'design-configuration/components/icons'

type SocialLinksProps = {
  twitter?: string | null
  instagram?: string | null
  website?: string | null
  artistPage?: ArtistEditorialPageDetailsFragment | null
}

export const SocialLinks = ({ twitter, instagram, website, artistPage }: SocialLinksProps): React.ReactElement => {
  return (
    <>
      {twitter?.length || instagram?.length || website?.length ? (
        <div className="gap-x-md flex items-center">
          {twitter?.length ? (
            <a
              href={twitter}
              onClick={() => {
                trackButtonClicked(TrackedButtonNames.socialLink, {
                  artistPage,
                  customProperties: {
                    'Social link type': 'Twitter',
                    'Social link to': twitter
                  }
                })
              }}
              target="_blank"
              rel="noreferrer"
            >
              <XLogoIcon className="fill-on-surface-inverted h-md w-md" />
            </a>
          ) : null}
          {instagram?.length ? (
            <a
              href={instagram}
              onClick={() => {
                trackButtonClicked(TrackedButtonNames.socialLink, {
                  artistPage,
                  customProperties: {
                    'Social link type': 'Instagram',
                    'Social link to': instagram
                  }
                })
              }}
              target="_blank"
              rel="noreferrer"
            >
              <InstagramLogoIcon className="fill-on-surface-inverted h-md w-md" />
            </a>
          ) : null}
          {website?.length ? (
            <a
              href={website}
              onClick={() => {
                trackButtonClicked(TrackedButtonNames.socialLink, {
                  artistPage,
                  customProperties: {
                    'Social link type': 'Website',
                    'Social link to': website
                  }
                })
              }}
              target="_blank"
              rel="noreferrer"
            >
              <GlobeIcon className="fill-on-surface-inverted h-md w-md" />
            </a>
          ) : null}
        </div>
      ) : null}
    </>
  )
}
